
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    // tslint:disable
    import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest, IQueryResultSettings } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
       
        // @ts-ignore
        function paymentExpressIntegrationQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("PaymentExpressIntegration", "GetTransactionIdEntity", DataServiceEntities.GetTransactionIdEntityExtensionClass, key);
        }

        
    export function createGetTransactionIdRequestInput(getTransactionIdEntity: DataServiceEntities.IGetTransactionIdEntity): IDataServiceRequest {
    const query = paymentExpressIntegrationQuery();
    return query.createDataServiceRequestForOperation('GetTransactionIdRequest', true, DataServiceEntities.GetTransactionIdEntityExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetTransactionIdEntity'}, {GetTransactionIdEntity: getTransactionIdEntity });
    }

    
    export function getTransactionIdRequestAsync(context: IContext, getTransactionIdEntity: DataServiceEntities.IGetTransactionIdEntity): AsyncResult<DataServiceEntities.IGetTransactionIdEntity> {
    const request = createGetTransactionIdRequestInput(getTransactionIdEntity);
    return callActionOrExecute<DataServiceEntities.IGetTransactionIdEntity>(request, context.callerContext);
    }
  
    export function createGetTransactionRequestInput(transactionId: string): IDataServiceRequest {
    const query = paymentExpressIntegrationQuery();
    return query.createDataServiceRequestForOperation('GetTransactionRequest', true, DataServiceEntities.GetTransactionEntityExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetTransactionEntity'}, {TransactionId: transactionId });
    }

    
    export function getTransactionRequestAsync(context: IContext, transactionId: string): AsyncResult<DataServiceEntities.IGetTransactionEntity> {
    const request = createGetTransactionRequestInput(transactionId);
    return callActionOrExecute<DataServiceEntities.IGetTransactionEntity>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function transactionResultsQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("TransactionResults", "GetTransactionEntity", DataServiceEntities.GetTransactionEntityExtensionClass, key);
        }

        
       
        // @ts-ignore
        function afterpayIntegrationQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("AfterpayIntegration", "DXC_AfterpayEntity", DataServiceEntities.DXC_AfterpayEntityExtensionClass, key);
        }

        
    export function createGetConfigurationInput(): IDataServiceRequest {
    const query = afterpayIntegrationQuery();
    return query.createDataServiceRequestForOperation('GetConfiguration', true, DataServiceEntities.DXC_GetConfigurationResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_GetConfigurationResponse'}, { });
    }

    
    export function getConfigurationAsync(context: IContext): AsyncResult<DataServiceEntities.IDXC_GetConfigurationResponse> {
    const request = createGetConfigurationInput();
    return callActionOrExecute<DataServiceEntities.IDXC_GetConfigurationResponse>(request, context.callerContext);
    }
  
    export function createCreateOrderInput(orderDetails: string): IDataServiceRequest {
    const query = afterpayIntegrationQuery();
    return query.createDataServiceRequestForOperation('CreateOrder', true, DataServiceEntities.DXC_CreateOrderResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_CreateOrderResponse'}, {orderDetails: orderDetails });
    }

    
    export function createOrderAsync(context: IContext, orderDetails: string): AsyncResult<DataServiceEntities.IDXC_CreateOrderResponse> {
    const request = createCreateOrderInput(orderDetails);
    return callActionOrExecute<DataServiceEntities.IDXC_CreateOrderResponse>(request, context.callerContext);
    }
  
    export function createGetOrderInput(token: string): IDataServiceRequest {
    const query = afterpayIntegrationQuery();
    return query.createDataServiceRequestForOperation('GetOrder', true, DataServiceEntities.DXC_GetOrderResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_GetOrderResponse'}, {token: token });
    }

    
    export function getOrderAsync(context: IContext, token: string): AsyncResult<DataServiceEntities.IDXC_GetOrderResponse> {
    const request = createGetOrderInput(token);
    return callActionOrExecute<DataServiceEntities.IDXC_GetOrderResponse>(request, context.callerContext);
    }
  
    export function createCapturePaymentInput(token: string): IDataServiceRequest {
    const query = afterpayIntegrationQuery();
    return query.createDataServiceRequestForOperation('CapturePayment', true, DataServiceEntities.DXC_CapturePaymentResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_CapturePaymentResponse'}, {token: token });
    }

    
    export function capturePaymentAsync(context: IContext, token: string): AsyncResult<DataServiceEntities.IDXC_CapturePaymentResponse> {
    const request = createCapturePaymentInput(token);
    return callActionOrExecute<DataServiceEntities.IDXC_CapturePaymentResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function laybuyIntegrationQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("LaybuyIntegration", "DXC_LaybuyEntity", DataServiceEntities.DXC_LaybuyEntityExtensionClass, key);
        }

        
    export function createLaybuyCreateOrderInput(orderDetails: string): IDataServiceRequest {
    const query = laybuyIntegrationQuery();
    return query.createDataServiceRequestForOperation('LaybuyCreateOrder', true, DataServiceEntities.DXC_LaybuyCreateOrderResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_LaybuyCreateOrderResponse'}, {orderDetails: orderDetails });
    }

    
    export function laybuyCreateOrderAsync(context: IContext, orderDetails: string): AsyncResult<DataServiceEntities.IDXC_LaybuyCreateOrderResponse> {
    const request = createLaybuyCreateOrderInput(orderDetails);
    return callActionOrExecute<DataServiceEntities.IDXC_LaybuyCreateOrderResponse>(request, context.callerContext);
    }
  
    export function createLaybuyConfirmOrderInput(token: string): IDataServiceRequest {
    const query = laybuyIntegrationQuery();
    return query.createDataServiceRequestForOperation('LaybuyConfirmOrder', true, DataServiceEntities.DXC_LaybuyConfirmOrderResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_LaybuyConfirmOrderResponse'}, {token: token });
    }

    
    export function laybuyConfirmOrderAsync(context: IContext, token: string): AsyncResult<DataServiceEntities.IDXC_LaybuyConfirmOrderResponse> {
    const request = createLaybuyConfirmOrderInput(token);
    return callActionOrExecute<DataServiceEntities.IDXC_LaybuyConfirmOrderResponse>(request, context.callerContext);
    }
  
    export function createLaybuyCancelOrderInput(token: string): IDataServiceRequest {
    const query = laybuyIntegrationQuery();
    return query.createDataServiceRequestForOperation('LaybuyCancelOrder', true, DataServiceEntities.DXC_LaybuyCancelOrderResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_LaybuyCancelOrderResponse'}, {token: token });
    }

    
    export function laybuyCancelOrderAsync(context: IContext, token: string): AsyncResult<DataServiceEntities.IDXC_LaybuyCancelOrderResponse> {
    const request = createLaybuyCancelOrderInput(token);
    return callActionOrExecute<DataServiceEntities.IDXC_LaybuyCancelOrderResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_CustomerQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_Customer", "DXC_CustomerEntity", DataServiceEntities.DXC_CustomerEntityExtensionClass, key);
        }

        
    export function createDXC_SubscribeNewsletterInput(firstName: string, lastName: string, emailAddress: string, streetNumber: string, streetAddress: string, suburb: string, city: string, postalCode: string, country: string, buildingCompliment: string): IDataServiceRequest {
    const query = dXC_CustomerQuery();
    return query.createDataServiceRequestForOperation('DXC_SubscribeNewsletter', true, DataServiceEntities.DXC_SubscribeNewsletterRealtimeResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_SubscribeNewsletterRealtimeResponse'}, {firstName: firstName, lastName: lastName, emailAddress: emailAddress, streetNumber: streetNumber, streetAddress: streetAddress, suburb: suburb, city: city, postalCode: postalCode, country: country, buildingCompliment: buildingCompliment });
    }

    
    export function dXC_SubscribeNewsletterAsync(context: IContext, firstName: string, lastName: string, emailAddress: string, streetNumber: string, streetAddress: string, suburb: string, city: string, postalCode: string, country: string, buildingCompliment: string): AsyncResult<DataServiceEntities.IDXC_SubscribeNewsletterRealtimeResponse> {
    const request = createDXC_SubscribeNewsletterInput(firstName, lastName, emailAddress, streetNumber, streetAddress, suburb, city, postalCode, country, buildingCompliment);
    return callActionOrExecute<DataServiceEntities.IDXC_SubscribeNewsletterRealtimeResponse>(request, context.callerContext);
    }
  
    export function createDXC_SubscribeEmailInput(emailAddress: string, subscribe: boolean): IDataServiceRequest {
    const query = dXC_CustomerQuery();
    return query.createDataServiceRequestForOperation('DXC_SubscribeEmail', true, DataServiceEntities.DXC_SubscribeNewsletterRealtimeResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_SubscribeNewsletterRealtimeResponse'}, {emailAddress: emailAddress, subscribe: subscribe });
    }

    
    export function dXC_SubscribeEmailAsync(context: IContext, emailAddress: string, subscribe: boolean): AsyncResult<DataServiceEntities.IDXC_SubscribeNewsletterRealtimeResponse> {
    const request = createDXC_SubscribeEmailInput(emailAddress, subscribe);
    return callActionOrExecute<DataServiceEntities.IDXC_SubscribeNewsletterRealtimeResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_GiftCardQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_GiftCard", "DXC_GiftCardEntity", DataServiceEntities.DXC_GiftCardEntityExtensionClass, key);
        }

        
    export function createGetGiftCardInput(giftCardId: string, pIN: string): IDataServiceRequest {
    const query = dXC_GiftCardQuery();
    return query.createDataServiceRequestForOperation('GetGiftCard', true, DataServiceEntities.DXC_GetGiftCardServiceResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_GetGiftCardServiceResponse'}, {giftCardId: giftCardId, PIN: pIN });
    }

    
    export function getGiftCardAsync(context: IContext, giftCardId: string, pIN: string): AsyncResult<DataServiceEntities.IDXC_GetGiftCardServiceResponse> {
    const request = createGetGiftCardInput(giftCardId, pIN);
    return callActionOrExecute<DataServiceEntities.IDXC_GetGiftCardServiceResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_ContactQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_Contact", "DXC_ContactEntity", DataServiceEntities.DXC_ContactEntityExtensionClass, key);
        }

        
    export function createCreateContactInput(name: string, emailAddress: string, phoneNumber: string, country: string, city: string, reasonForEnquiry: string, message: string): IDataServiceRequest {
    const query = dXC_ContactQuery();
    return query.createDataServiceRequestForOperation('CreateContact', true, DataServiceEntities.DXC_ContactResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_ContactResponse'}, {name: name, emailAddress: emailAddress, phoneNumber: phoneNumber, country: country, city: city, reasonForEnquiry: reasonForEnquiry, message: message });
    }

    
    export function createContactAsync(context: IContext, name: string, emailAddress: string, phoneNumber: string, country: string, city: string, reasonForEnquiry: string, message: string): AsyncResult<DataServiceEntities.IDXC_ContactResponse> {
    const request = createCreateContactInput(name, emailAddress, phoneNumber, country, city, reasonForEnquiry, message);
    return callActionOrExecute<DataServiceEntities.IDXC_ContactResponse>(request, context.callerContext);
    }

    export function createCreateContactCommercialInput(name: string, emailAddress: string, occupation: string,phoneNumber: string, enquiry: string, checkbox:boolean): IDataServiceRequest {
        const query = dXC_ContactQuery();
        return query.createDataServiceRequestForOperation('CreateContact', true, DataServiceEntities.DXC_ContactResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_ContactResponse'}, {name: name, emailAddress: emailAddress,occupation:occupation, phoneNumber: phoneNumber, enquiry: enquiry, checkbox:checkbox });
        }
    
        
        export function createContactCommercialAsync(context: IContext, name: string, emailAddress: string,occupation:string, phoneNumber: string,enquiry: string, checkbox: boolean): AsyncResult<DataServiceEntities.IDXC_ContactResponse> {
        const request = createCreateContactCommercialInput(name, emailAddress,occupation, phoneNumber, enquiry, checkbox);
        return callActionOrExecute<DataServiceEntities.IDXC_ContactResponse>(request, context.callerContext);
        }


  
       
        // @ts-ignore
        function dXC_StylingEnquiryQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_StylingEnquiry", "DXC_StylingEnquiryEntity", DataServiceEntities.DXC_StylingEnquiryEntityExtensionClass, key);
        }

        
    export function createCreateStylingEnquiryInput(firstName: string, lastName: string, email: string, phone: string, addressing: string, storeName: string, homeAreas: string, message: string, day: string, time: string, specificDateTime: string, pinterest: string, consultationType: string, channelId: string, subscribeToNewsletter: number): IDataServiceRequest {
    const query = dXC_StylingEnquiryQuery();
    return query.createDataServiceRequestForOperation('CreateStylingEnquiry', true, DataServiceEntities.DXC_StylingEnquiryResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_StylingEnquiryResponse'}, {firstName: firstName, lastName: lastName, email: email, phone: phone, addressing: addressing, storeName: storeName, homeAreas: homeAreas, message: message, day: day, time: time, specificDateTime: specificDateTime, pinterest: pinterest, consultationType: consultationType, channelId: channelId, subscribeToNewsletter: subscribeToNewsletter });
    }

    
    export function createStylingEnquiryAsync(context: IContext, firstName: string, lastName: string, email: string, phone: string, addressing: string, storeName: string, homeAreas: string, message: string, day: string, time: string, specificDateTime: string, pinterest: string, consultationType: string, channelId: string, subscribeToNewsletter: number): AsyncResult<DataServiceEntities.IDXC_StylingEnquiryResponse> {
    const request = createCreateStylingEnquiryInput(firstName, lastName, email, phone, addressing, storeName, homeAreas, message, day, time, specificDateTime, pinterest, consultationType, channelId, subscribeToNewsletter);
    return callActionOrExecute<DataServiceEntities.IDXC_StylingEnquiryResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_FreightChargesQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_FreightCharges", "DXC_FreightChargesEntity", DataServiceEntities.DXC_FreightChargesEntityExtensionClass, key);
        }

        
    export function createDXC_GetFreightChargesForPDPInput(postalCode: string, itemLine: DataServiceEntities.IDXC_ItemLine): IDataServiceRequest {
    const query = dXC_FreightChargesQuery();
    return query.createDataServiceRequestForOperation('DXC_GetFreightChargesForPDP', true, DataServiceEntities.DXC_GetFreightChargesServiceResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetFreightChargesServiceResponse'}, {postalCode: postalCode, itemLine: itemLine });
    }

    
    export function dXC_GetFreightChargesForPDPAsync(context: IContext, postalCode: string, itemLine: DataServiceEntities.IDXC_ItemLine): AsyncResult<DataServiceEntities.IDXC_GetFreightChargesServiceResponse> {
    const request = createDXC_GetFreightChargesForPDPInput(postalCode, itemLine);
    return callActionOrExecute<DataServiceEntities.IDXC_GetFreightChargesServiceResponse>(request, context.callerContext);
    }
  
    export function createDXC_GetFreightChargesForCartInput(postalCode: string, salesLines: Entities.SalesLine[], cartAmount: number): IDataServiceRequest {
    const query = dXC_FreightChargesQuery();
    return query.createDataServiceRequestForOperation('DXC_GetFreightChargesForCart', true, DataServiceEntities.DXC_GetFreightChargesServiceResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetFreightChargesServiceResponse'}, {postalCode: postalCode, salesLines: salesLines, cartAmount: cartAmount });
    }

    
    export function dXC_GetFreightChargesForCartAsync(context: IContext, postalCode: string, salesLines: Entities.SalesLine[], cartAmount: number): AsyncResult<DataServiceEntities.IDXC_GetFreightChargesServiceResponse> {
    const request = createDXC_GetFreightChargesForCartInput(postalCode, salesLines, cartAmount);
    return callActionOrExecute<DataServiceEntities.IDXC_GetFreightChargesServiceResponse>(request, context.callerContext);
    }
  
    export function createDXC_GetDeliveryOptionsInput(queryResultSettings: IQueryResultSettings, cartId: string, shippingAddress: Entities.Address, filterOption: number): IDataServiceRequest {
    const query = dXC_FreightChargesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('DXC_GetDeliveryOptions', true, EntityClasses.DeliveryOptionClass, 'true', {bypassCache: 'get', returnEntity: 'Entities.DeliveryOption'}, {cartId: cartId, shippingAddress: shippingAddress, filterOption: filterOption });
    }

    
    export function dXC_GetDeliveryOptionsAsync(context: IContext, cartId: string, shippingAddress: Entities.Address, filterOption: number): AsyncResult<Entities.DeliveryOption[]> {
    const request = createDXC_GetDeliveryOptionsInput(
      context.queryResultSettings || {}, cartId, shippingAddress, filterOption);
    return callActionOrExecute<Entities.DeliveryOption[]>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_ProductEnquiryQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_ProductEnquiry", "DXC_ProductEnquiryEntity", DataServiceEntities.DXC_ProductEnquiryEntityExtensionClass, key);
        }

        
    export function createCreateProductEnquiryInput(firstName: string, lastName: string, email: string, phone: string, storeName: string, product: string, enquiry: string, customisations: string, fabricType: string, fabricColour: string, consultationType: string, channelId: string, subscribeToNewsletter: number): IDataServiceRequest {
    const query = dXC_ProductEnquiryQuery();
    return query.createDataServiceRequestForOperation('CreateProductEnquiry', true, DataServiceEntities.DXC_ProductEnquiryResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_ProductEnquiryResponse'}, {firstName: firstName, lastName: lastName, email: email, phone: phone, storeName: storeName, product: product, enquiry: enquiry, customisations: customisations, fabricType: fabricType, fabricColour: fabricColour, consultationType: consultationType, channelId: channelId, subscribeToNewsletter: subscribeToNewsletter });
    }

    
    export function createProductEnquiryAsync(context: IContext, firstName: string, lastName: string, email: string, phone: string, storeName: string, product: string, enquiry: string, customisations: string, fabricType: string, fabricColour: string, consultationType: string, channelId: string, subscribeToNewsletter: number): AsyncResult<DataServiceEntities.IDXC_ProductEnquiryResponse> {
    const request = createCreateProductEnquiryInput(firstName, lastName, email, phone, storeName, product, enquiry, customisations, fabricType, fabricColour, consultationType, channelId, subscribeToNewsletter);
    return callActionOrExecute<DataServiceEntities.IDXC_ProductEnquiryResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_StockistsQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_Stockists", "DXC_StockistsEntity", DataServiceEntities.DXC_StockistsEntityExtensionClass, key);
        }

        
    export function createDXC_GetStockistsInput(countryCode: string, cityState: string, searchStr: string): IDataServiceRequest {
    const query = dXC_StockistsQuery();
    return query.createDataServiceRequestForOperation('DXC_GetStockists', true, DataServiceEntities.DXC_GetStockistsServiceResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetStockistsServiceResponse'}, {countryCode: countryCode, cityState: cityState, searchStr: searchStr });
    }

    
    export function dXC_GetStockistsAsync(context: IContext, countryCode: string, cityState: string, searchStr: string): AsyncResult<DataServiceEntities.IDXC_GetStockistsServiceResponse> {
    const request = createDXC_GetStockistsInput(countryCode, cityState, searchStr);
    return callActionOrExecute<DataServiceEntities.IDXC_GetStockistsServiceResponse>(request, context.callerContext);
    }
  
    export function createDXC_GetCountryMasterInput(): IDataServiceRequest {
    const query = dXC_StockistsQuery();
    return query.createDataServiceRequestForOperation('DXC_GetCountryMaster', true, DataServiceEntities.DXC_GetCountryMasterResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetCountryMasterResponse'}, { });
    }

    
    export function dXC_GetCountryMasterAsync(context: IContext): AsyncResult<DataServiceEntities.IDXC_GetCountryMasterResponse> {
    const request = createDXC_GetCountryMasterInput();
    return callActionOrExecute<DataServiceEntities.IDXC_GetCountryMasterResponse>(request, context.callerContext);
    }
  
    export function createDXC_GetCityStateMasterInput(countryCode: string): IDataServiceRequest {
    const query = dXC_StockistsQuery();
    return query.createDataServiceRequestForOperation('DXC_GetCityStateMaster', true, DataServiceEntities.DXC_GetCityStateMasterResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetCityStateMasterResponse'}, {countryCode: countryCode });
    }

    
    export function dXC_GetCityStateMasterAsync(context: IContext, countryCode: string): AsyncResult<DataServiceEntities.IDXC_GetCityStateMasterResponse> {
    const request = createDXC_GetCityStateMasterInput(countryCode);
    return callActionOrExecute<DataServiceEntities.IDXC_GetCityStateMasterResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_StoreLocationsQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_StoreLocations", "DXC_StoreLocationsEntity", DataServiceEntities.DXC_StoreLocationsEntityExtensionClass, key);
        }

        
    export function createGetStoreLocationsInput(searchKey: Entities.SearchArea): IDataServiceRequest {
    const query = dXC_StoreLocationsQuery();
    return query.createDataServiceRequestForOperation('GetStoreLocations', true, DataServiceEntities.DXC_StoreLocationsResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_StoreLocationsResponse'}, {searchKey: searchKey });
    }

    
    export function getStoreLocationsAsync(context: IContext, searchKey: Entities.SearchArea): AsyncResult<DataServiceEntities.IDXC_StoreLocationsResponse> {
    const request = createGetStoreLocationsInput(searchKey);
    return callActionOrExecute<DataServiceEntities.IDXC_StoreLocationsResponse>(request, context.callerContext);
    }
  
    export function createGetDefaultStoreLocationsInput(): IDataServiceRequest {
    const query = dXC_StoreLocationsQuery();
    return query.createDataServiceRequestForOperation('GetDefaultStoreLocations', true, DataServiceEntities.DXC_DefaultStoreLocationsResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_DefaultStoreLocationsResponse'}, { });
    }

    
    export function getDefaultStoreLocationsAsync(context: IContext): AsyncResult<DataServiceEntities.IDXC_DefaultStoreLocationsResponse> {
    const request = createGetDefaultStoreLocationsInput();
    return callActionOrExecute<DataServiceEntities.IDXC_DefaultStoreLocationsResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_AddressIntegrationQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_AddressIntegration", "DXC_AddressEntity", DataServiceEntities.DXC_AddressEntityExtensionClass, key);
        }

        
    export function createGetAddressInput(search: string): IDataServiceRequest {
    const query = dXC_AddressIntegrationQuery();
    return query.createDataServiceRequestForOperation('GetAddress', true, DataServiceEntities.DXC_GetNZPostAddressResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_GetNZPostAddressResponse'}, {search: search });
    }

    
    export function getAddressAsync(context: IContext, search: string): AsyncResult<DataServiceEntities.IDXC_GetNZPostAddressResponse> {
    const request = createGetAddressInput(search);
    return callActionOrExecute<DataServiceEntities.IDXC_GetNZPostAddressResponse>(request, context.callerContext);
    }
  
    export function createGetAddressDetailInput(address_id: string): IDataServiceRequest {
    const query = dXC_AddressIntegrationQuery();
    return query.createDataServiceRequestForOperation('GetAddressDetail', true, DataServiceEntities.DXC_GetNZPostAddressDetailResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IDXC_GetNZPostAddressDetailResponse'}, {address_id: address_id });
    }

    
    export function getAddressDetailAsync(context: IContext, address_id: string): AsyncResult<DataServiceEntities.IDXC_GetNZPostAddressDetailResponse> {
    const request = createGetAddressDetailInput(address_id);
    return callActionOrExecute<DataServiceEntities.IDXC_GetNZPostAddressDetailResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_StockOnHandQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_StockOnHand", "DXC_StockOnHandEntity", DataServiceEntities.DXC_StockOnHandEntityExtensionClass, key);
        }

        
    export function createDXC_GetStockAvailabilityInput(productId: number): IDataServiceRequest {
    const query = dXC_StockOnHandQuery();
    return query.createDataServiceRequestForOperation('DXC_GetStockAvailability', true, DataServiceEntities.DXC_GetStockAvailabilityResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetStockAvailabilityResponse'}, {productId: productId });
    }

    
    export function dXC_GetStockAvailabilityAsync(context: IContext, productId: number): AsyncResult<DataServiceEntities.IDXC_GetStockAvailabilityResponse> {
    const request = createDXC_GetStockAvailabilityInput(productId);
    return callActionOrExecute<DataServiceEntities.IDXC_GetStockAvailabilityResponse>(request, context.callerContext);
    }
  
       
        // @ts-ignore
        function dXC_RetailTransactionQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("DXC_RetailTransaction", "DXC_GetRetailTransactionEntity", DataServiceEntities.DXC_GetRetailTransactionEntityExtensionClass, key);
        }

        
    export function creategetRetailTransactionInput(sqlName: string): IDataServiceRequest {
    const query = dXC_RetailTransactionQuery();
    return query.createDataServiceRequestForOperation('getRetailTransaction', true, DataServiceEntities.DXC_GetRetailTransactionResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IDXC_GetRetailTransactionResponse'}, {sqlName: sqlName });
    }

    
    export function getRetailTransactionAsync(context: IContext, sqlName: string): AsyncResult<DataServiceEntities.IDXC_GetRetailTransactionResponse> {
    const request = creategetRetailTransactionInput(sqlName);
    return callActionOrExecute<DataServiceEntities.IDXC_GetRetailTransactionResponse>(request, context.callerContext);
    }
  